import ApiSignals, { ApiSignalFetchers } from "@/apis/api_signals"
import { computed } from "@preact/signals"
import { createLogger } from "@/utils/logger"

const logger = createLogger("")

// API 相關方法
async function fetchTransactionTypes() {
    await ApiSignalFetchers.fetchDataSignalTransactionTypes()
}

const transactionTypes = computed(() => {
    return ApiSignals.dataSignalTransactionTypes.value
})

const clearTransactionTypes = () => {
    ApiSignals.dataSignalTransactionTypes.value = []
}

export { fetchTransactionTypes, clearTransactionTypes, transactionTypes }
